import React from 'react';
import DesktopVideoCards from "/components/Video/DesktopVideoCards";
import MobileVideoCards from "/components/Video/MobileVideoCards";
import ReadAll from './readAll';
import ContentTitle from "/components/contentTitle";
import ReadAllLinkForTab from '/components/Brand/ReadAllLinkForTab';

export function DesktopVideoCardsSection(props) {
  const { items, readAllClick, brandProfileName, routeName, paramsName, readAll, color, contentTitle, newsItems, maxNum, removeTitle, brandTab } = props;
  return (
        <div style={{padding: 1, backgroundColor: '#1f1f1f'}}>
          {!removeTitle && 
            <ContentTitle contentTitle={contentTitle} color={color} style={{display: 'none'}} />
          }
          <DesktopVideoCards items={items} newsItems={newsItems} maxNum={maxNum}/>
          {
            brandTab ? 
              <ReadAllLinkForTab 
                tabIndex={2} 
                readAllClick={readAllClick} 
                color={color} 
                readAll={readAll} 
              />
            :
            <ReadAll items={items} routeName={routeName} paramsName={paramsName} readAll={readAll} color={color} />

          }
        </div>
    );
}

export function MobileVideoCardsSection(props) {
    const { items, routeName, paramsName, readAll, color, contentTitle, newsItems, maxNum, removeTitle, brandTab, readAllClick } = props;
    return (
          <div style={{padding: '0', marginBottom: 10, backgroundColor: '#1f1f1f'}}>
            {!removeTitle && 
              <div style={{ padding: 10 }}>            
                <ContentTitle contentTitle={contentTitle} color={color} />
              </div>
            }
            <MobileVideoCards items={items} newsItems={newsItems} maxNum={maxNum} />
            {
            brandTab ? 
              <ReadAllLinkForTab 
                tabIndex={2} 
                readAllClick={readAllClick} 
                color={color} 
                readAll={readAll} 
              />
            :
            <ReadAll items={items} routeName={routeName} paramsName={paramsName} readAll={readAll} color={color} />
            }
            </div>
      );
  }


